import { cn } from '@anytag/shared-utils';
import { TableV2, TableV2Props } from '@anytag/shared-atoms';

export type AnalyticsCompareTagsRankingTableProps<TData, TValue> = TableV2Props<TData, TValue>;
export const AnalyticsCompareTagsRankingTable = <TData, TValue>({
  className,
  hasBorder = false,
  noTopBorderRadius = true,
  ...restProps
}: AnalyticsCompareTagsRankingTableProps<TData, TValue>) => (
  <TableV2
    hasBorder={hasBorder}
    noTopBorderRadius={noTopBorderRadius}
    className={cn(
      '[&_[data-slot="table-cell"]:first-of-type]:border-r-border',
      '[&_[data-slot="table-cell"]:last-of-type]:px-0!',
      className
    )}
    {...restProps}
  />
);
